import React, { useEffect, useState } from 'react'
import {
  IconButton,
  Icon,
  Typography,
} from '@mui/material'

import * as srv from 'admin/services'
import { formatDateTimeSeconds } from 'admin/utils/helper'
import { useStores, useApiRequest } from 'admin/hooks'

const SyncButton = () => {
  const [currentSync, setCurrentSync] = useState(null)
  const { customerStore, notificationStore } = useStores()
  const {
    request: syncCustomer,
    isLoading,
  } = useApiRequest(srv.syncCustomer, { blocking: true })
  const {
    request: fetchCurrentSync,
  } = useApiRequest(srv.fetchCurrentSync, { blocking: true })

  const fetchSync = async () => {
    try {
      const response = await fetchCurrentSync('customer')
      setCurrentSync(response.data)
    } catch (error) {
      notificationStore.setError(error)
    }
  }

  const handleSync = async () => {
    if (isLoading) return
    const res = await syncCustomer()
    if (!res) return

    await customerStore.reload()
    fetchSync()
    notificationStore.setSuccess('Customer is sync')
  }

  useEffect(() => {
    fetchSync()
  }, [])

  return (
    <div style={{ display: 'flex' }}>
      <IconButton
        variant="contained"
        color="secondary"
        onClick={handleSync}
        disabled={isLoading}
        size="large"
      >
        <Icon>sync</Icon>
      </IconButton>
      {currentSync?.syncUpdatedAt && (
        <div>
          <Typography variant="body2">
            Last Sync
          </Typography>
          <Typography variant="body2">
            {formatDateTimeSeconds(currentSync.syncUpdatedAt)}
          </Typography>
        </div>
      )}
    </div>
  )
}

export default SyncButton
